<script>
  import { zhouyitw, zhouyicn } from "../etc/zhouyi.js"
  import { selectedLanguage } from "../etc/store.js"
  // import { gua64, guabook1, guabook2 } from "../etc/gua64.js"

  import {
    findGua,
    number2code,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    reverseString,
    btn_style_blue_d2,
    btn_style_red_d2,
    btn_style_yellow_d2,
  } from "../etc/helpers.js"

  export let numStr
  export let gua_code

  //$: console.log("@ ShowYaoText: Got numStr: " + numStr)
  //$: console.log("@ ShowYaoText: Got gua_code: " + gua_code)

  let zhouyi = zhouyitw
  $: if ($selectedLanguage == "TW") {
    zhouyi = zhouyitw
  } else {
    zhouyi = zhouyicn
  }

  let showYaoText = false
  $: numStr.length != 0 ? (showYaoText = true) : (showYaoText = false)

  let changingYao = checkChanging(numStr)
  let movingYaos = getMovingYaoPositions(numStr)
  let movingYaoArray = getMovingYaoPositions(numStr).split(",")
  $: gua_code = number2code(numStr)
  let reversed_code = reverseString(gua_code)
  let yaoColor = []
  let lastYao = []

  let yaoArray = []
  let yaoXiangArray = []
  // let yong6 = ""
  // let yong9 = ""
  // console.log(zhouyi["101101"])
  // console.log(zhouyi["101101"].yao1)

  function getYaoInfo(code, lang) {
    yaoArray = []
    yaoXiangArray = []
    // yong9 = ""
    // yong6 = ""
    if (showYaoText) {
      // console.log(zhouyi[code])
      yaoArray.push(zhouyi[code].yao6)
      yaoArray.push(zhouyi[code].yao5)
      yaoArray.push(zhouyi[code].yao4)
      yaoArray.push(zhouyi[code].yao3)
      yaoArray.push(zhouyi[code].yao2)
      yaoArray.push(zhouyi[code].yao1)

      yaoXiangArray.push(zhouyi[code].yaoXiang6)
      yaoXiangArray.push(zhouyi[code].yaoXiang5)
      yaoXiangArray.push(zhouyi[code].yaoXiang4)
      yaoXiangArray.push(zhouyi[code].yaoXiang3)
      yaoXiangArray.push(zhouyi[code].yaoXiang2)
      yaoXiangArray.push(zhouyi[code].yaoXiang1)

      // yong9 = zhouyi[code].yong9
      // yong6 = zhouyi[code].yong6
    }
  }

  $: getYaoInfo(gua_code, $selectedLanguage)
</script>

<div class=" guatext">
  {#if showYaoText}
    <table class="striped">
      <tbody>
        {#each yaoArray as yao, i}
          <tr>
            <td>{yao}</td>
            <td>{yaoXiangArray[i]}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</div>

<style></style>
